import { API_ENDPOINT } from './Api';
import requestInstance from './Request';
import { setCurrentUser } from 'utils/utils';

let env = process.env.REACT_APP_B2B_API_BASE_URL

export const chooseYourServiceApi = async (data) => {
  const res = await requestInstance
    .get(
      `${env}${
        API_ENDPOINT.ChooseYourService.api +
        '?id=' +
        data?.id +
        '&type=' +
        data?.type +
        '&businessType=' +
        data?.businessType
      }`
    )
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const addChooseYourServiceApi = async (data) => {
  const res = await requestInstance
    .post(`${env}${API_ENDPOINT.ChooseYourService.api}`, data)
    .catch((err) => err.response);
  return setCurrentUser(res);
};

export const updateChooseYourServiceApi = async (data) => {
  const res = await requestInstance
    .patch(
      `${env}${API_ENDPOINT.ChooseYourService.api}`,
      data
    )
    .catch((err) => err.response);
  return setCurrentUser(res);
};
